import { gql } from "@apollo/client";
const CALCULATESCORE = gql`
  query calculateGroupScore($filter: ListGroupInput) {
    calculateGroupScore(filter: $filter)
  }
`;
export default CALCULATESCORE;